export const formatPriceForApi = (number: string | number): string => `${number}`.replace(',', '.')

export const formatPriceForRead = (number: string): string => `${number}`.replace('.', ',')
